import _classCallCheck from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/apps/legacy-open/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import dotProp from 'dot-prop-immutable';
import Router from 'next/router';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isProduction } from '@/lib/env-utils';
import EventApiRender from '@/lib/event-api/render';
import { isAppUrl } from '@/lib/organization-utils';
import UserAgent from '@/lib/user-agent';
import * as errorActions from '@/redux/actions/error';
import { getError } from '@/redux/selectors/error';
import IconCloudClock from '@/icons/cloud-clock.svg';
import IconCloudRemove from '@/icons/cloud-remove.svg';
import IconFaceAstonished from '@/icons/face-astonished.svg';
import IconHexagon from '@/icons/hexagon.svg';
import IconWifiOff from '@/icons/wifi-off.svg';
import theme from '@/theme';
import ErrorPage from '@/components/error/page';
import UILink from '@/components/legacy/ui/link';
import UIIcon from '@/components/ui/icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var apiURL = "".concat(String(process.env.API_PROTOCOL), "://").concat(String(process.env.API_HOST));

var mapStateToProps = function mapStateToProps(state) {
  return {
    error: getError(state)
  };
};

var mapDispatchToProps = {
  catchError: errorActions.catchError,
  resetError: errorActions.resetError
};
var connector = connect(mapStateToProps, mapDispatchToProps);

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      error: null
    });

    _defineProperty(_assertThisInitialized(_this), "onActionClick", function () {
      var resetError = _this.props.resetError;
      resetError();

      if (_this.status === 403) {
        if (isAppUrl(document.referrer)) {
          Router.back();
          return;
        }

        Router.push('/');
        return;
      }

      if (_this.status === 404) {
        Router.push('/');
        return;
      }

      Router.reload();
    });

    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (UserAgent.isMobileApp()) {
        EventApiRender.completed();
      }
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, extra) {
      var catchError = this.props.catchError;
      catchError(error, extra);
    }
  }, {
    key: "actionLabelId",
    get: function get() {
      if (this.status === 403) {
        if (isAppUrl(document.referrer)) {
          return 'dialog.action.back';
        }

        return 'error.page.homePage';
      }

      if (this.status === 404) {
        return 'error.page.homePage';
      }

      return 'retry';
    }
  }, {
    key: "code",
    get: function get() {
      return dotProp.get(this.state, 'error.code');
    }
  }, {
    key: "extraInfo",
    get: function get() {
      if (!this.unavailable) {
        return null;
      }

      if (isProduction()) {
        return null;
      }

      return /*#__PURE__*/_jsxs("p", {
        children: ["Please check connection to ", /*#__PURE__*/_jsx(UILink, {
          href: apiURL,
          children: apiURL
        }), "."]
      });
    }
  }, {
    key: "icon",
    get: function get() {
      if (this.offline) {
        return /*#__PURE__*/_jsx(UIIcon, {
          as: IconWifiOff,
          color: theme['error.icon.color'],
          size: 196
        });
      }

      if (this.timeout) {
        return /*#__PURE__*/_jsx(UIIcon, {
          as: IconCloudClock,
          color: theme['error.icon.color'],
          size: 196
        });
      }

      if (this.unavailable) {
        return /*#__PURE__*/_jsx(UIIcon, {
          as: IconCloudRemove,
          color: theme['error.icon.color'],
          size: 196
        });
      }

      if (this.status === 403 || this.status === 404) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UIIcon, {
            as: IconHexagon,
            color: theme['error.icon.color'],
            size: 196
          }), /*#__PURE__*/_jsx("span", {
            children: this.status
          })]
        });
      }

      return /*#__PURE__*/_jsx(UIIcon, {
        as: IconFaceAstonished,
        color: theme['error.icon.color'],
        size: 196
      });
    }
  }, {
    key: "message",
    get: function get() {
      return dotProp.get(this.state, 'error.message');
    }
  }, {
    key: "networkError",
    get: function get() {
      return this.message === 'Network Error';
    }
  }, {
    key: "offline",
    get: function get() {
      return !navigator.onLine && this.networkError;
    }
  }, {
    key: "timeout",
    get: function get() {
      return this.code === 'ECONNABORTED';
    }
  }, {
    key: "reportable",
    get: function get() {
      if (this.offline) {
        return false;
      }

      if (this.timeout) {
        return false;
      }

      if (this.unavailable) {
        return false;
      }

      if (this.status) {
        return this.status >= 500;
      }

      return true;
    }
  }, {
    key: "status",
    get: function get() {
      return dotProp.get(this.state, 'error.response.status');
    }
  }, {
    key: "type",
    get: function get() {
      if (this.offline) {
        return 'offline';
      }

      if (this.timeout) {
        return 'timeout';
      }

      if (this.unavailable) {
        return 'unavailable';
      }

      if (this.status === 403) {
        return '403';
      }

      if (this.status === 404) {
        return '404';
      }

      return 'default';
    }
  }, {
    key: "unavailable",
    get: function get() {
      return navigator.onLine && this.networkError;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var error = this.state.error;
      return /*#__PURE__*/_jsx(_Fragment, {
        children: error ? /*#__PURE__*/_jsx(FormattedMessage, {
          id: this.actionLabelId,
          children: function children(actionLabel) {
            return /*#__PURE__*/_jsx(ErrorPage, {
              actionLabel: actionLabel,
              error: error,
              extraInfo: _this2.extraInfo,
              icon: _this2.icon,
              reportable: _this2.reportable,
              type: _this2.type,
              onActionClick: _this2.onActionClick
            });
          }
        }) : children
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref) {
      var error = _ref.error;
      return {
        error: error
      };
    }
  }]);

  return ErrorBoundary;
}(Component);

export default withRouter(connector(ErrorBoundary));